import { atom } from "jotai";

export type PersonaRole =
  | "compliance-officer"
  | "investigator"
  | "revenue-recovery"
  | "intelligence-analyst"
  | "team-leader"
  | "executive-director";

export type PersonaDensity = "guided" | "compact";

export interface PersonaState {
  userId: string;
  name: string;
  role: PersonaRole;
  roleLabel: string;
  density: PersonaDensity;
  teamId: string | null;
  teamName: string | null;
  permissions: string[];
}

export const personaAtom = atom<PersonaState>({
  userId: "user-001",
  name: "Alex Morehu",
  role: "compliance-officer",
  roleLabel: "Customer Compliance Specialist",
  density: "guided",
  teamId: "team-compliance",
  teamName: "SME Compliance",
  permissions: [],
});
